<template>
<div>
    <div class="pgment-5">
        <div class="func-menu" :style="'height:' + leftHt + 'px'">
            <!-- <div class="item-seek">

      	   <el-input size="small" placeholder="请输入检索内容" suffix-icon="el-icon-search"></el-input>

      </div> -->
            <el-tree class="filter-tree" :data="gmpTree" :props="gmpTreeProps" :filter-node-method="filterNode" @node-click="handleNodeClick" ref="tree2">
            </el-tree>
        </div>

        <div class="role-list">
            <el-scrollbar :style="'height:' + leftHt + 'px'">
                <div class="scroll-inner">
                    <div class="query">
                        <el-select size="medium" @change="onChange" clearable v-model="seekStore.userType" placeholder="用户类型">
                            <el-option v-for="item in userTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input class="headSeek" v-model="seekStore.where" size="medium" placeholder="输入帐号或者手机号" />
                        <el-button class="newAdd" type="primary" size="medium" @click="userPocts({ type: 'show', code: 1 })">新增</el-button>
                    </div>
                    <el-table :data="tabDat" style="width: 100%">
                        <!-- <el-table-column label="序号" align="center" width="90">
                          <template slot-scope="scope">
                              <span>{{ scope.$index + 1 + 15*(seekStore.no - 1) }}</span>
                          </template>
                        </el-table-column> -->
                        <el-table-column label="账号" width="150" prop="account">
                        </el-table-column>
                        <el-table-column label="姓名" width="100" prop="name">
                        </el-table-column>
                        <el-table-column label="所在机构" prop="organizationName">
                        </el-table-column>
                        <el-table-column label="手机号" width="150" prop="cellPhone">
                        </el-table-column>
                        <!-- <el-table-column label="所属单位" width="150" prop="danwei">
                        </el-table-column>
                        <el-table-column label="所属功能区" width="150" prop="ownePark">
                        </el-table-column> -->
                        <el-table-column :width="styleSet.edWidth" label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="resetPwd(scope.row)">重置密码</el-button>
                                <el-button size="mini" @click="userPocts({ type: 'show', code: 2, dats: scope.row }) ">修改</el-button>
                                <el-button size="mini" type="warning" @click="rolePocts({ type: 'show', dats: scope.row })">权限</el-button>
                                <el-button size="mini" type="danger" @click="userPocts({ type: 'remove', dats: scope.row })">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-scrollbar>
            <div class="pg-figs">
                <el-pagination layout="total,prev, pager, next" :current-page="seekStore.no" @current-change="pageChange" :page-size="seekStore.size" :total="allEls">
                </el-pagination>
            </div>
        </div>

        <el-dialog :title="userPop.diaTitle" class="pgment-5-dag" :visible.sync="userPop.diaCtrls" width="450px" center>
            <!-- <el-row class="textRow">
                <el-col :span="5" class="ttName">
                    <span>账号类型：</span>
                </el-col>
                <el-col :span="18">
                    <el-radio-group v-model="userPop.userType">
                        <el-radio :label="1">楼宇</el-radio>
                        <el-radio :label="2">街乡</el-radio>
                    </el-radio-group>
                </el-col>
            </el-row> -->
            <el-row class="textRow">
                <el-col :span="5" class="ttName">
                    <span>帐号：</span>
                </el-col>
                <el-col :span="18">
                    <el-input size="small" v-model="userPop.account" />
                </el-col>
            </el-row>
            <el-row class="textRow">
                <el-col :span="5" class="ttName">
                    <span>姓名：</span>
                </el-col>
                <el-col :span="18">
                    <el-input size="small" v-model="userPop.name" />
                </el-col>
            </el-row>
            <!-- <el-row class="textRow">
                <el-col :span="5" class="ttName">
                    <span>所属单位：</span>
                </el-col>
                <el-col :span="18">
                    <el-input size="small" v-model="userPop.danwei" />
                </el-col>
            </el-row>
            <el-row class="textRow">
                <el-col :span="5" class="ttName">
                    <span>所属功能区：</span>
                </el-col>
                <el-col :span="18">
                    <el-input size="small" v-model="userPop.ownePark" />
                </el-col>
            </el-row> -->
            <el-row class="textRow">
                <el-col :span="5" class="ttName">
                    <span>手机：</span>
                </el-col>
                <el-col :span="18">
                    <el-input size="small" v-model="userPop.cellPhone" />
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="5" class="ttName">
                    <span>邮箱：</span>
                </el-col>
                <el-col :span="18">
                    <el-input size="small" v-model="userPop.email" />
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="userPocts({ type: 'cencel' })" size="small">取 消</el-button>
                <el-button class="inContent" type="primary" @click="userPocts({ type: 'sure' })" size="small">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="权限配置" class="pgment-5-dag2" :visible.sync="rolePop.diaCtrls" width="540px" center>
            <el-row>
                <el-col :span="3" class="ttName">
                    <span>角色：</span>
                </el-col>
                <el-col :span="21">
                    <template>
                        <el-checkbox-group class="checkGp" v-model="rolePop.chosenArrs" @change="userDefine">
                            <el-checkbox v-for="role in rolePop.roleArrs" :label="role.id" :key="role.id">{{ role.name }}</el-checkbox>
                        </el-checkbox-group>
                    </template>
                </el-col>
            </el-row>
            <el-row class="dag2-row">
                <el-col :span="3" class="ttName">
                    <span>权限：</span>
                </el-col>
                <el-col :span="21">
                    <div class="dagInner">
                        <el-scrollbar>
                            <el-tree :data="enterTree" ref="tree" empty-text="" node-key="id" :check-strictly="true" :show-checkbox="false" :props="enterTreeProps">
                            </el-tree>
                        </el-scrollbar>
                    </div>
                </el-col>
            </el-row>

            <span slot="footer" class="dialog-footer">
                <el-button @click="rolePocts({ type: 'cencel' })" size="small">取 消</el-button>
                <el-button class="inContent" type="primary" @click="rolePocts({ type: 'sure' })" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</div>
</template>

<script>
import {
    getGmpTree,
    getUserList,
    getConfiged,
    getRoles,
    userConnectRole,
    userCreate,
    userRemove,
    getUserRoles,
    userUpdate,
    resetPasswordFormAdmin
} from '@/api/pgMent/userMent';

export default {
    data() {
        return {
            styleSet: {
                edWidth: 320,
            },
            leftHt: 0,
            userTypeOptions: [{
                value: 1,
                label: '楼宇'
            }, {
                value: 2,
                label: '街乡'
            }],
            // 机构树

            gmpTree: [],
            gmpTreeProps: {
                children: 'getCompanyPostModules',
                label: 'name'
            },

            // 用列表默认缓存

            seekStore: {
                no: 1,
                size: 12,
                where: '',
                organizationId: '',
                id: '',
                userType: ''
            },
            allEls: 0,
            tabDat: [],
            tabPages: 0,

            // 新增、修改用户基础信息

            userPop: {
                diaCtrls: false,
                diaTitle: '',
                name: '',
                cellPhone: '',
                uId: '',
                account: '',
                email: '',
                danwei: '',
                ownePark: '',
                userType: 0
            },

            // 配置用户角色

            rolePop: {
                userId: '',
                diaCtrls: false,
                roleArrs: [],
                chosenArrs: [],
                tmpRole: {},
            },

            // 角色关联权限树

            enterTree: [],
            enterTreeProps: {
                children: 'menuRuleModules',
                label: 'name'
            },

        }

    },
    watch: {
        'seekStore.where': function () {
            this.seekStore.no = 1;
            this.userList();
        }
    },
    methods: {
        onChange: function (e) {
            console.log(e);
            this.seekStore.userType = e;
            this.userList();
        },
        /*
         * 获取机构树
         */
        gmpTreeInit: function () {
            getGmpTree().then(response => {
                let unFormate = response.getCompanyPostTreeModules;
                this.gmpTree = unFormate;

                this.seekStore.organizationId = unFormate[0].id;
                this.seekStore.no = 1;
                this.userList();
                this.gmpRolesGet(unFormate[0].id);

            }).catch(error => {
                console.log(error);
            })
        },
        /*
         * 获取当前机构下用户列表 (列表刷新通用)
         */
        userList: function () {
            var _basePage = {
                no: this.seekStore.no,
                size: this.seekStore.size,
            };
            this.seekStore.basePage = _basePage;
            getUserList(this.seekStore).then(response => {
                this.tabDat = response.userModules;
                this.tabPages = response.totalPages;
                this.allEls = response.totalElements;
            }).catch(error => {
                console.log(error);
            })
        },
        /*
         * 新增、修改用户基础信息
         */
        userPocts: function ({
            type,
            code,
            dats
        }) {

            if (type == 'show') {
                if (code == 1) {
                    this.userPop.diaTitle = '新增账号';
                    this.userPop.name = '';
                    this.userPop.cellPhone = '';
                    this.userPop.account = '';
                    this.userPop.email = '';
                    this.userPop.danwei = '';
                    this.userPop.ownePark = '';
                    this.userPop.uId = '';
                    this.userPop.userType = 0;
                } else if (code == 2) {
                    this.userPop.diaTitle = '修改账号信息';
                    this.userPop.account = dats.account;
                    this.userPop.name = dats.name;
                    this.userPop.email = dats.email;
                    this.userPop.danwei = dats.danwei;
                    this.userPop.ownePark = dats.ownePark;
                    this.userPop.cellPhone = dats.cellPhone;
                    this.userPop.uId = dats.id;
                    this.userPop.userType = dats.userType;
                }
                this.userPop.diaCtrls = true;
            } else if (type == 'cencel') {
                this.userPop.diaCtrls = false;
            } else if (type == 'sure') {
                this.userPop.account.replace(/\s+/g, "");
                if (this.userPop.account.length < 2) {
                    this.$message.error('账号不能少于2个字符！');
                } else if (!this.userPop.name) {
                    this.$message.error('用户姓名必须填写');
                // } else if (!this.userPop.danwei) {
                //     this.$message.error('所属单位必须填写');
                // } else if (!this.userPop.ownePark) {
                //     this.$message.error('所属功能区必须填写');
                } else if (!this.userPop.cellPhone) {
                    this.$message.error('手机号必须填写');
                // } else if (!this.userPop.userType) {
                //     this.$message.error('用户类型必须选择');
                } else {

                    // console.log(this.userPop);
                    let pattern = /^1[3|4|5|7|8][0-9]{9}$/;
                    if (pattern.test(this.userPop.cellPhone)) {
                        if (this.userPop.uId) {
                            userUpdate({
                                account: this.userPop.account,
                                name: this.userPop.name,
                                cellPhone: this.userPop.cellPhone,
                                id: this.userPop.uId,
                                organizationId: this.seekStore.organizationId,
                                danwei: this.userPop.danwei,
                                ownePark: this.userPop.ownePark,
                                email: this.userPop.email,
                                userType: this.userPop.userType
                            }).then(response => {
                                this.$message.success('修改成功');
                                this.$emit('go-frash');
                            })
                        } else {
                            userCreate({
                                account: this.userPop.account,
                                name: this.userPop.name,
                                cellPhone: this.userPop.cellPhone,
                                organizationId: this.seekStore.organizationId,
                                danwei: this.userPop.danwei,
                                ownePark: this.userPop.ownePark,
                                email: this.userPop.email,
                                userType: this.userPop.userType
                            }).then(response => {
                                this.$message.success('新建帐号成功，默认密码为“123456”');
                                this.$emit('go-frash');
                            })
                        }
                    } else {
                        this.$message.error('手机号错误');
                    }

                }

            } else if (type == "remove") {
                this.$confirm('确定要删除账号"' + dats.account + '"吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    userRemove({
                        id: dats.id
                    }).then(response => {
                        this.$message({
                            showClose: true,
                            message: '删除成功！',
                            type: 'success'
                        });
                        this.$emit('go-frash');
                    });
                }).catch(error => {

                });

            }

        },
        resetPwd: function (data) {
            this.$confirm('确定要重置"' + data.account + '"密码吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                resetPasswordFormAdmin({
                    userId: data.id
                }).then(response => {
                    this.$message({
                        showClose: true,
                        message: '重置密码成功，新密码为“Cqj@#$123456”！',
                        type: 'success'
                    });
                });
            }).catch(error => {

            });
        },
        /*
         * 修改用户角色配置
         */

        rolePocts: function ({
            type,
            dats
        }) {
            if (type == "show") {
                this.rolePop.diaCtrls = true;
                this.rolePop.tempRole = dats;
                getUserRoles({
                    userId: dats.id
                }).then(response => {
                    let unFormate = response.userModule.postIds;
                    if (unFormate) {
                        this.rolePop.chosenArrs = unFormate.split(",");
                    } else {
                        this.rolePop.chosenArrs = [];
                    }
                    this.userDefine();
                })
            } else if (type == "cencel") {
                this.rolePop.diaCtrls = false;
            } else if (type == "sure") {
                this.rolePop.tempRole.postIds = this.rolePop.chosenArrs;
                userConnectRole(this.rolePop.tempRole).then(response => {
                    this.$message({
                        showClose: true,
                        message: '配置成功！',
                        type: 'success'
                    });
                    this.rolePop.diaCtrls = false;
                })
            }
        },

        /*
         * 根据角色获取权限
         */

        userDefine: function () {
            if (this.rolePop.chosenArrs.length > 0) {
                getConfiged({
                    postIds: this.rolePop.chosenArrs
                }).then(response => {
                    this.enterTree = response.menuRuleTreeModules;
                }).catch(error => {
                    console.log(error);
                })
            } else {
                this.enterTree = [];
            }

        },

        /*
         * 机构检索
         */

        filterNode: function (value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },

        /*
         * 机构变动
         */

        handleNodeClick: function (data) {
            if (this.seekStore.organizationId != data.id) {
                this.seekStore.no = 1;
                this.seekStore.organizationId = data.id;
                this.userList();
                this.gmpRolesGet(data.id);
            }

        },

        /*
         * 机构角色
         */

        gmpRolesGet: function (inId) {
            getRoles({
                id: inId,
                type: 4
            }).then(response => {
                let newArr = [];
                this.rolePop.roleArrs = response.getCompanyPostModules;
            })
        },

        /*
         * 分页
         */

        pageChange: function (inx) {
            this.seekStore.no = inx;
            this.userList();
        }

    },

    beforeMount: function () {
        this.gmpTreeInit();
    },

    created: function () {
        let bdHt = document.body.clientHeight;
        let wsHt = document.documentElement.clientHeight;
        // if(bdHt > wsHt){
        // 		this.leftHt = bdHt - 140;
        // }else{
        // 		this.leftHt = wsHt - 140;
        // }

        this.leftHt = wsHt - 140;

        let scWidth = document.documentElement.clientWidth;
        if (scWidth <= 1280) {
            this.styleSet.edWidth = 420;
        }
    }
}
</script>

<style>
.query {
    margin-top: 16px;
    margin-bottom: 16px;
}

.pgment-5 {
    padding-left: 1px;
    position: relative;
    /*padding: 20px 30px;*/
}

/* 角色树 */

.pgment-5 .func-menu {
    width: 240px;
    /* border-right: 1px solid #ebeef5; */
    position: absolute;
    left: 1px;
    top: 0px;
}

.pgment-5 .filter-tree {
    margin: 12px 6px;
}

.pgment-5 .item-seek {
    padding: 15px 9px;
    border-bottom: 1px solid #ebeef5;
}

.pgment-5 .treeitem {
    padding: 6px 0px;
}

/* 角色列表 */

.pgment-5 .role-list {
    margin-left: 240px;
    border-left: 1px solid #ebeef5;
    padding: 0px 20px;
    position: relative;
}

.pgment-5 .role-list .headSeek {
    width: 180px;
    vertical-align: middle;
    display: inline-block;
}

.pgment-5 .role-list .newAdd {
    width: 90px;
    vertical-align: middle;
    display: inline-block;
}

.pgment-5 .el-scrollbar__wrap {
    overflow-x: hidden;
}

.pgment-5 .el-tree-node .el-tree-node__content {
    padding: 3px 0px 5px;
}

/* 创建弹出层 */

.pgment-5-dag .btncage {
    text-align: center;
}

/* .pgment-5-dag .el-button {
    width: 90px;
} */

.pgment-5-dag .el-dialog__footer {
    padding-bottom: 24px;
}

.pgment-5-dag .textRow {
    margin-bottom: 24px;
}

.pgment-5-dag .ttName {
    text-align: right;
    line-height: 26px;
}

.pgment-5-dag .ttName span {
    margin-right: 12px;
    vertical-align: middle;
}

/* 配置弹出层 */

.pgment-5-dag2 .dagInner .el-scrollbar__wrap {
    max-height: 450px;
    padding: 20px 0px;
    overflow-x: hidden;
}

.pgment-5-dag2 .ttName span {
    margin-left: 9px;
}

.pgment-5-dag2 .checkGp .el-checkbox {
    margin-right: 24px;
    margin-left: 0px;
    margin-bottom: 9px;
}

.pgment-5-dag2 .dag2-row .ttName {
    padding-top: 24px;
}

/* 分页 */

.pgment-5 .pg-figs {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
}
</style><style>
@media screen and (max-width: 1280px) {
    .pgment-5 .role-list {
        margin-left: 210px;
    }

    .pgment-5 .role-list .headSeek {
        width: 300px;
        vertical-align: middle;
        display: inline-block;
    }

    .pgment-5 .func-menu {
        width: 210px;
    }
}
</style>



// WEBPACK FOOTER //
// userMent.vue?0b3238a8